<template>
  <div id="phenotype-tag-container" @mouseenter="e => mouse = true" @mouseleave="e => mouse = false">
    <input
      ref="comment-input"
      type="text"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="content"
      @focus="e => focus = true"
      @blur="e => focus = false"
      @keydown.up.prevent.stop="e => moveTagIndex('up')"
      @keydown.down.prevent.stop="e => moveTagIndex('down')"
      @keydown.enter.prevent.stop="e => (phenotypes || []).length <= 1 ? $emit('send', content) : commentTag()"
      @input="e => commentOnInput(true)"
      @change="e => $emit('change', content)"
    >
    <div class="input-tag" v-if="phenotypes && !onCompelete && display && content">
      <div class="tag-block">
        <template v-if="phenotypes.length > 0">
          <div v-if="dataInfo['hpo'] && dataInfo['disease_term']" class="tag-info-container">
            <div class="tag-info-block">
              <span>{{ 'Showing ' + [(dataInfo['hpo'].displayed ? dataInfo['hpo'].displayed + '/' + dataInfo['hpo'].total + ' phenotypes' : ''), (dataInfo['disease_term'].displayed ? dataInfo['disease_term'].displayed + '/' + dataInfo['disease_term'].total + ' diseases' : '')].filter(x => x).join(' and ') }}</span>
            </div>
          </div>
          <div ref="tag-block" class="tag-group-container">
            <div v-if="filtedPhenotypes['hpo'] && filtedPhenotypes['hpo'].length" class="tag-group-block">
              <div class="tag-title">Phenotype</div>
              <div class="tag" v-for="(tag, index) in filtedPhenotypes['hpo']" :key="index" :class="{ selected: tagIndex === index }" @mousemove="e => tagIndex = index" @click="commentTag()">
                <span v-html="tag.query.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
            <div v-if="filtedPhenotypes['disease_term'] && filtedPhenotypes['disease_term'].length" class="tag-group-block">
              <div class="tag-title">Disease</div>
              <div class="tag" v-for="(tag, index) in filtedPhenotypes['disease_term']" :key="index - -(filtedPhenotypes['hpo'] || []).length" :class="{ selected: tagIndex === index - -(filtedPhenotypes['hpo'] || []).length }" @mousemove="e => tagIndex = index - -(filtedPhenotypes['hpo'] || []).length" @click="commentTag()">
                <span v-html="tag.query.replace(new RegExp(content, 'ig'), m => '<span class=\'key\'>' + m + '</span>')"></span>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="tab-empty">{{ 'No result has been found.'/* ___ */ }}</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from '../../constants/global/util'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    init: {
      type: String,
      default: () => ''
    },
    dataInfo: {
      type: Object,
      default: () => null
    },
    phenotypes: {
      type: Array,
      default: () => null
    },
    placeholder: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      content: '',
      tagIndex: 0,
      onCompelete: false,
      focus: false,
      mouse: false,
      display: false
    }
  },
  computed: {
    filtedPhenotypes () {
      return groupBy(this.phenotypes, phenotype => phenotype.type, true)
    }
  },
  watch: {
    'init' () {
      if (this.content !== this.init) {
        this.content = this.init
      }
    },
    'focus' () {
      this.display = this.focus || this.mouse
    }
  },
  created () {
    if (this.content !== this.init) {
      this.content = this.init
    }
  },
  methods: {
    commentOnInput (compelete) {
      compelete && (this.onCompelete = false)
      this.tagIndex = 0
      this.$emit('input', this.content)
    },
    moveTagIndex (type) {
      switch (type) {
        case 'up': {
          this.tagIndex = (this.tagIndex - -this.phenotypes.length - 1) % this.phenotypes.length
          break
        }
        case 'down': {
          this.tagIndex = (this.tagIndex - -1) % this.phenotypes.length
          break
        }
      }
      this.$refs['tag-block'].scrollTop = 28 * this.tagIndex
    },
    commentTag () {
      const curTag = this.phenotypes[this.tagIndex]
      this.onCompelete = true
      this.content = curTag.query
      this.$emit('tag', curTag)
      this.commentOnInput()
      this.$refs['comment-input'].focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#phenotype-tag-container
  position: relative
  input
    width: 100%
    &:hover
      & + .description-tag
        .info-container
          opacity: 1
          top: 58px
    &:focus
      & + .description-tag
        .info-container
          opacity: 0
          top: -9999999999999999px
  .input-tag
    position: absolute
    width: 100%
    top: 36px
    overflow: hidden
    z-index: 5
    .tag-block
      width: 100%
      box-sizing: border-box
      padding: 5px 0
      background: white
      border-radius: 3px
      border: 1px solid #003679
      z-index: 100
      .tag-info-container
        width: 100%
        padding: 0 5px
        margin-bottom: 7px
        box-sizing: border-box
        .tag-info-block
          width: 100%
          padding: 3px 5px
          box-sizing: border-box
          background: #F8FAFA
          border-radius: 3px
          color: #003679
      .tag-group-container
        overflow-y: auto
        max-height: 400px
        .tag-group-block
          & > div
            width: 100%
          &:not(:last-child)
            margin-bottom: 8px
          .tag-title
            color: #003679
            margin-bottom: 7px
            padding: 0 10px
            font-weight: 500
            box-sizing: border-box
          .tag
            padding: 3px 10px
            cursor: pointer
            user-select: none
            box-sizing: border-box
            word-break: break-word
            &.selected
              background: #003679
              color: white
              .key
                color: white
            span
              white-space: pre
            .key
              color: #003679
      .tab-empty
        color: #999999
        font-weight: 300
        padding: 0 10px
</style>



// WEBPACK FOOTER //
// src/components/tool/phenotypeTag.vue